<template>
  <div class="report column">
    <Header />
    <Button layout="back" @click="router.back()" class="show-s">
      <i class="fa fa-arrow-left"></i> Voltar
    </Button>
    <div class="container">
      <div class="content">
        <iframe :src="user.url_relatorio" frameborder="0"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import router from "@/router";
import { mapGetters } from "vuex";
export default {
  name: "Report",
  components: {
    Button,
  },
  data() {
    return {
      router: router,
    };
  },
  computed: {
    ...mapGetters("user", ["user"]),
  },
};
</script>


<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;
.report {
  .container {
    padding: 42px 35px;
    text-align: center;
    background: $white-1;

    @media (max-width: $small) {
      padding: 7px;
    }
    .title {
      letter-spacing: -0.26px;
      color: $gray-9;
      font-size: 30px;
      font-weight: bold;
      text-align: center;
    }
    iframe {
      width: 75%;
      height: 84vh;
      margin: auto;
      box-shadow: $shadow;
      border-radius: 21px;
    }
  }
}
</style>
